module.exports = __webpack_public_path__ + "img/cnh.f797e7e7.jpg";